import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import api from '@/services/api';
import { Checkbox  } from '@mui/material';

import CustomSelect from '@/views/components/CustomSelect/CustomSelect';

import styles from '@/views/pages/SimpleTextAdvicesAdmin/SimpleTextAdvicesAdmin.module.scss';

const TablePublish = ({questions, getQuestions, publish, handleChangesort, sortValue, sortOptions, pages, setAlert}) => {
	const [ idsToChange, setIdsToChange ] = useState([]);
	const dict = useSelector(state => state.app.dict);

	const getAnswerAuthor = (question) => {
		if(question?.answer?.externalAuthor) {
			return <p className={ styles['admin__table__text'] } >{question.answer.externalAuthor.forename} {question.answer.externalAuthor.surname}</p>;
		} else if (question?.answer?.author?.displayName) {
			return <>
				<p className={ styles['admin__table__text'] } >{question.answer.author.displayName}</p>
				<p className={ styles['admin__table__tooltip'] }>{question.answer.author.email}</p>
			</>;
		} else {
			return '';
		}
	};

	const handlePublish = async (id) => {
		try {
			const {data} = await api.put(`/questions/${id}/${publish ?  'unpublish' : 'publish'}`);
			if (data) {
				getQuestions();
				setAlert({content: `${publish ? dict.simpleTextAdvices.admin.alert.unpublished : dict.simpleTextAdvices.admin.alert.published }`, variant: 'success'});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleSelectAll = (e) => {
		if(e.target.checked){
			const ids = questions.map(({id}) => (id));
			setIdsToChange(ids);
		} else {
			setIdsToChange([]);
		}
	};

	const publishChecked = async () => {
		const queryString = idsToChange.map(id => `ids=${id}`).join('&');
		try {
			const {data} = await api.put(`/questions/${publish ?  'unpublish' : 'publish'}?${queryString}`);
			if (data) {
				getQuestions();
				setAlert({content: `${publish ? dict.simpleTextAdvices.admin.alert.unpublished : dict.simpleTextAdvices.admin.alert.published }`, variant: 'success'});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleCheckbox = (e, idToChange) => {
		if(e.target.checked){
			setIdsToChange([ ...idsToChange, idToChange ]);
		} else {
			const ids = idsToChange.filter((id) => (id !== idToChange));
			setIdsToChange(ids);
		}
	};

	useEffect(() => {
		setIdsToChange([]);
	}, [ questions ]);

	return (
		<>
			<div className={ `${styles[`admin__table__buttons${pages > 0 ? '-absolute' : ''}`]}` }>
				<button 
					disabled={ idsToChange.length === 0 }
					className='button__blue'
					onClick={ ()=> publishChecked() }>
					{publish ? dict.simpleTextAdvices.admin.tablePublish.button.unpublishAll :  dict.simpleTextAdvices.admin.tablePublish.button.publishAll}
				</button>
				<div className={ `${styles['admin__table__select']}` }>
					<CustomSelect
						options={ sortOptions } 
						value={ sortValue }
						onChange={ handleChangesort }
						placeholder=""
						label={ dict.simpleTextAdvices.admin.sort }
						inline
					/> 
				</div>
			</div>
			<div className={ `${styles['admin__table__header-container']}` }>
				<div className={ `${styles['admin__table__head']} ${styles['admin__table__head--publish']}` }>
					<div>
						<div className={ `${styles['admin__table__checkbox-container']}` }>
							<Checkbox 
								className='admin__table--all'
								onChange={ (e)=> handleSelectAll(e) }
								checked={ idsToChange.length === questions.length }
							/>
						</div>
					</div>
					<div>
						{dict.simpleTextAdvices.admin.tablePublish.label.id}
					</div>
					<div >
						{dict.simpleTextAdvices.admin.tablePublish.label.provider}
					</div>
					<div >
						{dict.simpleTextAdvices.admin.tablePublish.label.department}
					</div>
					<div >
						{dict.simpleTextAdvices.admin.tablePublish.label.responser}
					</div>
					<div>
						{dict.simpleTextAdvices.admin.tablePublish.label.sendDate}
					</div>
					<div>{dict.simpleTextAdvices.admin.tablePublish.label.comments}</div>
					<div></div>
				</div>
			</div>
			{questions && questions.map(question => 
				(
					<div 
						key={ question.id }
						className={ `${styles['admin__table__item']} ${styles['admin__table__item--publish']}  ${idsToChange.includes(question.id) && styles['admin__table__item--selected']}` }
					>
						<div className={ styles['admin__table__checkbox'] }>
							<Checkbox className='admin__table'
								checked={ idsToChange.includes(question.id) }
								value={ question.id }
								onChange={ (e) => handleCheckbox(e, question.id) }
							/>
						</div>
						<div className={ styles['admin__table__cell'] }>
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tablePublish.label.id}:</p>
							<Link className={ styles['admin__table__link'] }
								to={ `/simple-text-advice/${question.id}?admin-advices` }>{dict.simpleTextAdvices.admin.tablePublish.question} {question.id}</Link>
							<p className={ styles['admin__table__content'] }>{question.content}</p>
						</div>
						<div className={ `${styles['admin__table__cell']} ${styles['admin__table__item--col']}` } >
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tablePublish.label.provider}:</p>
							<p className={ styles['admin__table__text'] } >{question.author.displayName}</p>
							<p className={ styles['admin__table__tooltip'] }>{question.author.email}</p>
						</div>
						<div className={ styles['admin__table__item--col'] }>
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tablePublish.label.department}:</p>
							<p className={ styles['admin__table__text'] } >{question?.author?.departments[0]?.name}</p>
						</div>
						<div className={ `${styles['admin__table__cell']} ${styles['admin__table__item--col']}` }>
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tablePublish.label.responser}:</p>
							{getAnswerAuthor(question)}
						</div>
						<div className={ styles['admin__table__item--col'] }>
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tablePublish.label.sendDate}:</p>
							<p className={ styles['admin__table__text'] } >{question.updatedOn.replaceAll('-', '.')}</p>
						</div>
						<div className={ styles['admin__table__item--col'] }>
							<p className={ styles['admin__table__label'] }>{dict.simpleTextAdvices.admin.tablePublish.label.comments}: </p>
							{question.comments.length}
						</div>
						<div className={ styles['admin__table__button-publish'] }>	
							<button 
								className='button__transparent'
								onClick={ () => handlePublish(question.id) }
							>
								{publish ? dict.simpleTextAdvices.admin.tablePublish.button.unpublish : dict.simpleTextAdvices.admin.tablePublish.button.publish}
							</button>
						</div>
					</div>
				),
			)}
		</>
	);
};

export default TablePublish;